<template>
    <main>
        <!-- Hero 视频区域 -->
        <HeroCarousel />

        <!-- 1. Product Grid (AI-1) -->
        <section class="section product-grid" data-aos="fade-up">
            <div class="container grid-container">
                <div class="grid-item" data-aos="fade-right">
                    <img :src="productGrid.image" :alt="productGrid.alt" />
                </div>
                <div class="grid-item" data-aos="fade-left">
                    <h3>{{ productGrid.title }}</h3>
                    <p>{{ productGrid.description }}</p>
                    <router-link :to="productGrid.link" class="cta-button">Learn More</router-link>
                </div>
            </div>
        </section>

        <!-- 2. Feature Split (AI-2) -->
        <FeatureSplit v-bind="featureSplit" />

        <!-- 3. Apple Modules (AI-3, XPRO-1) -->
        <AppleModule v-for="(module, idx) in appleModules" :key="'apple-' + idx" v-bind="module" />

        <!-- 4. Dual Wrappers -->
        <DualWrapper v-for="(wrapper, idx) in dualWrappers" :key="'dual-' + idx" v-bind="wrapper" />
    </main>
</template>

<script>
import HeroCarousel from '@/components/HeroCarousel.vue';
import FeatureSplit from '@/components/FeatureSplit.vue';
import AppleModule from '@/components/AppleModule.vue';
import DualWrapper from '@/components/DualWrapper.vue';
import AOS from 'aos';
import 'aos/dist/aos.css';
import {
    productGridData,
    featureSplitData,
    appleModulesData,
    dualWrappersData,
} from '@/config/products.js';

export default {
    name: 'Home',
    components: {
        HeroCarousel,
        FeatureSplit,
        AppleModule,
        DualWrapper,
    },
    data() {
        return {
            productGrid: productGridData,
            featureSplit: featureSplitData,
            appleModules: appleModulesData,
            dualWrappers: dualWrappersData,
        };
    },
    mounted() {
        // 在 DOM 加载完成后初始化 AOS
        this.$nextTick(() => {
            AOS.init({
                duration: 800,
                once: true,
                offset: 100,
                disableMutationObserver: true, // 避免监听 DOM 变化导致的循环
            });
        });
    },
    beforeDestroy() {
        // 刷新 AOS（实际无 destroy 方法，但刷新可以清理一些内部状态）
        // 通过重新初始化并传入 disable 来停止监听（但最简单的是不做额外操作，因为组件销毁后 AOS 的监听还在，但不影响新页面）
        // 更彻底：移除 AOS 添加的滚动事件监听（下面会手动处理）
        if (window.__AOS) {
            window.removeEventListener('scroll', window.__AOS.refresh);
        }
    },
};
</script>

<style scoped>
/* 原 product-grid 的样式 */
.section.product-grid {
    padding: 80px 0;
    background-color: #fff;
}

.grid-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 60px;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 24px;
}

.grid-item {
    flex: 1;
}

.grid-item img {
    max-width: 100%;
    border-radius: 20px;
}

.grid-item h3 {
    font-size: 2rem;
    font-weight: 600;
    margin-bottom: 12px;
}

.grid-item p {
    font-size: 1.1rem;
    color: #6c757d;
    margin-bottom: 24px;
}

.cta-button {
    display: inline-block;
    background-color: #0071e3;
    color: white;
    padding: 12px 28px;
    border-radius: 40px;
    text-decoration: none;
    font-weight: 500;
}

.cta-button:hover {
    background-color: #005bb5;
}

@media (max-width: 768px) {
    .grid-container {
        flex-direction: column;
        text-align: center;
    }

    .grid-item h3 {
        font-size: 1.5rem;
    }
}
</style>